import float_btn from 'src/assets/main/main_up_btn.png'
import Main9Section from 'src/component/Main/Main9Section'
import {MainWrap, MainPcFloatBtn, MainMoFloatBtn} from 'src/styles/views/Main'
import Main5Section from 'src/component/Main/Main5Section'
import Main2Section from 'src/component/Main/Main2Section'
import Main3Section from 'src/component/Main/main3Section'
import Main4Section from 'src/component/Main/Main4Section'
import Main1Section from 'src/component/Main/Main1Section'
import Main6Section from 'src/component/Main/Main6Section'
import Main7Section from 'src/component/Main/Main7Section'
import Main8Section from 'src/component/Main/Main8Section'
import {useScroll} from 'src/hooks/useScroll'
import useWindowDimensions from 'src/hooks/useGetWindowSize'
import React, {useState} from 'react'
import {useRecoilValue} from 'recoil'
import {MoHeaderMenuToggle} from "src/store/recoil/common"
import {APP_STORE_WARD, IOS_APP_STORE_WARD, MO_APP_STORE_WARD} from "src/service/constant/url"
import {deviceDetection} from "src/service/utils";


const Main = () => {
    const scrollup = useScroll()
    const [moFloatBtn, setMoFloatBtn] = useState(false)
    const [pcFloatBtn, setPcFloatBtn] = useState(false)
    const {width} = useWindowDimensions()
    const menuToggle = useRecoilValue(MoHeaderMenuToggle)
    const onClickAppDownload = () => {
        switch(deviceDetection()){
            case "AOS":
                window.open(width > 1200 ? APP_STORE_WARD : MO_APP_STORE_WARD)
                break
            case "IOS":
                window.open(IOS_APP_STORE_WARD)
                break
        }
    }
    window.addEventListener('scroll', function () {
        if (window.scrollY > 2120) {
            setPcFloatBtn(true)
        } else {
            setPcFloatBtn(false)
        }
        if (window.scrollY > 0) {
            setMoFloatBtn(true)
        } else {
            setMoFloatBtn(false)
        }
    })

    /*20231024 lgu+ 가입/해지 불가 모달*/
    /*const {flag} = useNoticeModal("2023-10-16 00:00:00", "2023-10-23 08:00:00")
    const [open, setOpen] = useState(true)
    useEffect(() => {
        if (open && flag()) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
    }, [open, flag])*/
    return (
        <MainWrap>
            {/*20231024 lgu+ 가입/해지 불가 모달*/}
            {/*{flag() && <Modal isOpen={open} toggle={() => setOpen(!open)} type={'notice'} ClickFunc={() => setOpen(!open)}/>}*/}
            <Main1Section/>
            <Main2Section/>
            <Main3Section/>
            <Main4Section/>
            <Main5Section/>
            <Main6Section/>
            <Main7Section/>
            <Main8Section/>
            <Main9Section/>
            {width > 1200
                ? <>
                    {pcFloatBtn && <MainPcFloatBtn src={float_btn} onClick={scrollup.scrollTop}/>}
                </>
                : <MainMoFloatBtn active={`${!menuToggle && moFloatBtn && 'active'}`} onClick={onClickAppDownload}>
                    <span>앱 설치하기</span>
                </MainMoFloatBtn>}

        </MainWrap>
    )
}
export default Main
